<template>
  <RouterView />
</template>

<script setup>
</script>

<style>
html, body, #app { height: 100%; }
</style>
